<template>
  <!-- Footer -->
  <footer :class="{ isMobile }" class="footer">
    <div class="footer-content">
      <p class="logo">
        <img :src="footerLogo" alt="" />
      </p>
      <ul>
        <li>
          <p class="title">{{ $t("footer.text1") }}</p>
          <p class="text">
            {{ $t("footer.text2") }}
          </p>
        </li>

        <li v-if="!isMobile">
          <p class="title">{{ $t("footer.text3") }}</p>
          <p @click="handleOpen(extensionUrl)" class="text fw-600 text-underline">
            {{ $t("footer.text4") }}
          </p>
        </li>
        <li>
          <p class="title">{{ $t("footer.text5") }}</p>
          <p @click="handleOpen(helpDocUrl)" class="text text-underline cursor-pointer">
            {{ $t("footer.text6") }}
          </p>
        </li>
        <li>
          <p class="title">{{ $t("footer.text7") }}</p>
          <p
            @click="handleOpen(privacyPolicyUrl)"
            class="text cursor-pointer text-underline"
          >
            {{ $t("footer.text8") }}
          </p>
        </li>
        <li>
          <p class="title">{{ $t("footer.text9") }}</p>
          <div class="text">
            <p class="info-1">
              <img src="@/assets/images/influenbase-email.png" alt="" />
              <span> influenbase@brandpal.ai</span>
            </p>
            <p v-if="language == 'zh'" class="info-2">
              <img src="@/assets/images/influenbase-phone.png" alt="" />
              <span> {{ $t("footer.text11") }}</span>
            </p>
          </div>
        </li>
        <li>
          <p class="info-3">
            <img :src="contactUrl" alt="" />
          </p>
        </li>
      </ul>

      <div v-if="!isMobile && language === 'zh'" class="links">
        <p>友情链接</p>
        <div>
          <span
            @click="handleOpen(item.url)"
            v-for="(item, index) in linksData"
            :key="index"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>
  </footer>

  <downloadDialog v-model="showDownloadDialog"></downloadDialog>
</template>

<script setup lang="ts">
import { useGetLanguage } from "@/hooks/useGetLanguage";
import { useDevice } from "@/hooks/useDevice";
import downloadDialog from "@/components/Dialog/downloadDialog.vue";
import { ref } from "vue";
import { getConfig } from "@/utils";

const { isMobile } = useDevice();

const {
  extensionUrl,
  privacyPolicyUrl,
  contactUrl,
  helpDocUrl,
  language,
  footerLogo,
} = useGetLanguage();

const handleOpen = (url: string) => {
  if (isMobile) {
    window.location.href = url;
  } else {
    window.open(url);
  }
};

const showDownloadDialog = ref(false);
const handleShowModal = () => {
  showDownloadDialog.value = true;
};

const linksData = JSON.parse(getConfig("bp_landing_page_friendship_links_zh"));
</script>

<style scoped lang="scss">
.footer {
  background-color: #9038ff;
  color: #fff;
  .footer-content {
    width: 1200px;
    margin: auto;
    padding-top: 63px;
    padding-bottom: 16px;

    .logo {
      img {
        width: 186px;
      }
    }

    ul {
      margin-top: 70px;
      display: grid;
      grid-template-columns: 200px 160px 140px 120px 200px 126px;
      gap: 50px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      li {
        .title {
          margin-bottom: 34px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
        }
        .text-underline {
          text-decoration: underline;
          cursor: pointer;
        }

        .info-1,
        .info-2 {
          display: flex;
          align-items: center;
          img {
            width: 18px;
            height: 18px;
            margin-right: 6px;
          }
          margin-bottom: 16px;
        }

        .info-3 {
          width: 126px;
          img {
            width: 126px;
            height: 126px;
          }
          span {
            width: 96px;
            display: block;
            text-align: center;
            margin: auto;
          }
        }
      }
    }

    .links {
      margin-top: 60px;
      font-family: PingFang SC, PingFang SC;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 117px;
      p {
        font-weight: 600;
        margin-bottom: 34px;
      }

      div {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        span {
          margin-bottom: 34px;
          width: 20%;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}

.isMobile {
  padding: 0 30px;
  padding-bottom: 60px;
  width: 100vw;
  .logo {
    img {
      width: 324px;
    }
  }
  .footer-content {
    width: 100%;
    ul {
      margin-top: 60px;
      width: 100%;
      display: block !important;
      li {
        margin-bottom: 60px;

        .title {
          margin-bottom: 24px;
          font-size: 24px;
        }
        .text {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
